// <reference path="../../../../typings/index.d.ts" />
import * as React from 'react';


class ConfirmModalV4 extends React.Component {
    constructor(props) {
        super(props);
        this.okFunction = this.okFunction.bind(this);
        this.koFunction = this.koFunction.bind(this);
        this.state = {
            pulsanteOK: "SI",
            pulsanteKO: "NO",
        }
    }

    okFunction() {
        console.log('[ConfirmModal]: okFunction: ');
        if (typeof this.props.okFunction === 'function') {
            this.props.okFunction();
        }
    }

    koFunction() {
        console.log('[ConfirmModal]: koFunction: ');
        if (typeof this.props.koFunction === 'function') {
            this.props.koFunction();
        }
    }

    render() {
        return (
            <div id={this.props.id} className="modal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog" role="document">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h4 className="modal-title" id="myModalLabel">{this.props.titolo}</h4>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>

                        </div>
                        <div className="modal-body">
                            {this.props.testo !== null && this.props.testo !== undefined ?
                                <h4>{this.props.testo}</h4> : null}
                            {this.props.content !== null && this.props.content !== undefined ?
                                <div>{this.props.content}</div> : null}
                        </div>
                        <div className="modal-footer">
                            <div className="float-left">
                                <button type="button" className="btn btn-primary" data-dismiss="modal" style={{ marginRight: 350 }}
                                    onClick={this.okFunction}>{this.props.pulsanteOK ? this.props.pulsanteOK : "SI"}</button>
                            </div>
                            <button type="button" className="btn btn-secondary" data-dismiss="modal"
                                onClick={this.koFunction}>{this.props.pulsanteKO ? this.props.pulsanteKO : "NO"}</button>

                        </div>
                    </div>
                </div>
            </div>
        );
    }
};


export default ConfirmModalV4;